<template>
  <div class="contact-form-section">
    <SectionHeader
      icon="fas fa-envelope"
      title="Scrivici"
      subtitle="Scegli il tipo di messaggio e compila il form"
    />
    
    <div class="message-type-selector">
      <button
        type="button"
        class="type-button"
        :class="{ active: messageType === 'contact' }"
        @click="messageType = 'contact'"
      >
        <i class="fas fa-comment"></i>
        <span>Contatto Generale</span>
      </button>
      <button
        type="button"
        class="type-button"
        :class="{ active: messageType === 'bug' }"
        @click="messageType = 'bug'"
      >
        <i class="fas fa-bug"></i>
        <span>Segnala Bug</span>
      </button>
    </div>

    <SectionCard>
      <form @submit.prevent="handleSubmit" class="contact-form">
      <transition name="fade" mode="out-in">
        <div :key="messageType">
          <div v-if="messageType === 'contact'" class="form-fields">
            <div class="form-row">
              <FormInput
                id="name"
                label="Nome completo"
                v-model="form.name"
                required
                placeholder="Mario Rossi"
              />
              <FormInput
                id="email"
                label="Email"
                type="email"
                v-model="form.email"
                required
                placeholder="mario.rossi@esempio.com"
              />
            </div>
            <FormInput
              id="subject"
              label="Oggetto"
              v-model="form.subject"
              required
              placeholder="Di cosa vuoi parlare?"
            />
            <FormTextarea
              id="message"
              label="Messaggio"
              v-model="form.message"
              required
              placeholder="Scrivi il tuo messaggio qui..."
              :rows="6"
            />
          </div>
          
          <div v-else class="form-fields">
            <FormInput
              id="bug-email"
              label="La tua email"
              type="email"
              v-model="form.email"
              required
              placeholder="la-tua-email@esempio.com"
            />
            <FormInput
              id="bug-subject"
              label="Breve descrizione del problema"
              v-model="form.subject"
              required
              placeholder="Es: L'app si blocca quando..."
            />
            <FormTextarea
              id="bug-description"
              label="Descrizione dettagliata"
              v-model="form.message"
              required
              placeholder="Descrivi il problema in dettaglio, quando si verifica, cosa stavi facendo, ecc..."
              :rows="6"
            />
            <FormTextarea
              id="bug-steps"
              label="Passaggi per riprodurre (opzionale)"
              v-model="form.steps"
              placeholder="1. Apri l'app...&#10;2. Vai su...&#10;3. Il problema si verifica quando..."
              :rows="4"
            />
          </div>
        </div>
      </transition>

        <div class="form-actions">
          <SubmitButton
            :text="messageType === 'contact' ? 'Invia Messaggio' : 'Segnala Bug'"
            :disabled="isSubmitting"
          />
        </div>
        
        <FormMessage
          :message="submitMessage"
          :type="submitMessageClass"
        />
      </form>
    </SectionCard>
  </div>
</template>

<script>
import FormInput from '../../components/contattaci/FormInput.vue'
import FormTextarea from '../../components/contattaci/FormTextarea.vue'
import SectionHeader from '../../components/contattaci/SectionHeader.vue'
import SectionCard from '../../components/contattaci/SectionCard.vue'
import SubmitButton from '../../components/contattaci/SubmitButton.vue'
import FormMessage from '../../components/contattaci/FormMessage.vue'

export default {
  name: 'ContactForm',
  components: {
    FormInput,
    FormTextarea,
    SectionHeader,
    SectionCard,
    SubmitButton,
    FormMessage
  },
  data() {
    return {
      messageType: 'contact',
      form: {
        name: '',
        email: '',
        subject: '',
        message: '',
        steps: ''
      },
      isSubmitting: false,
      submitMessage: '',
      submitMessageClass: ''
    }
  },
  watch: {
    messageType() {
      // Reset form quando cambia il tipo di messaggio
      this.form = {
        name: '',
        email: '',
        subject: '',
        message: '',
        steps: ''
      }
      this.submitMessage = ''
    }
  },
  methods: {
    async handleSubmit() {
      this.isSubmitting = true
      this.submitMessage = ''

      try {
        // Qui puoi aggiungere la logica per inviare il form
        // Per ora simuliamo un invio
        await new Promise(resolve => setTimeout(resolve, 1500))
        
        const successMessage = this.messageType === 'contact' 
          ? 'Messaggio inviato con successo! Ti risponderemo al più presto.'
          : 'Bug segnalato con successo! Grazie per il tuo contributo.'
        
        this.submitMessage = successMessage
        this.submitMessageClass = 'success'
        this.form = {
          name: '',
          email: '',
          subject: '',
          message: '',
          steps: ''
        }
      } catch (error) {
        this.submitMessage = 'Si è verificato un errore. Riprova più tardi.'
        this.submitMessageClass = 'error'
      } finally {
        this.isSubmitting = false
        setTimeout(() => {
          this.submitMessage = ''
        }, 5000)
      }
    }
  }
}
</script>

<style scoped>
.contact-form-section {
  margin-bottom: 80px;
}


.message-type-selector {
  display: flex;
  gap: 16px;
  margin-bottom: 40px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.type-button {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 16px 24px;
  background: #f9fafb;
  border: 2px solid #e5e7eb;
  border-radius: 16px;
  font-size: 1rem;
  font-weight: 600;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.type-button::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, #2a5298 0%, #1e3c72 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.type-button i,
.type-button span {
  position: relative;
  z-index: 1;
  transition: color 0.3s ease;
}

.type-button i {
  font-size: 1.25rem;
}

.type-button:hover {
  border-color: #2a5298;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(42, 82, 152, 0.15);
}

.type-button.active {
  background: linear-gradient(135deg, #2a5298 0%, #1e3c72 100%);
  border-color: #2a5298;
  color: #ffffff;
  box-shadow: 0 4px 16px rgba(42, 82, 152, 0.3);
}

.type-button.active::before {
  opacity: 1;
}

.contact-form {
  width: 100%;
}

.form-fields {
  animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  margin-bottom: 24px;
}

@media (max-width: 768px) {
  .form-row {
    grid-template-columns: 1fr;
  }
  
  .message-type-selector {
    flex-direction: column;
    gap: 12px;
  }
  
  .type-button {
    padding: 14px 20px;
  }
}

.form-actions {
  margin-top: 32px;
  text-align: center;
}
</style>

